import { render, staticRenderFns } from "./poiList.vue?vue&type=template&id=74d2c0ba&"
import script from "./poiList.vue?vue&type=script&lang=js&"
export * from "./poiList.vue?vue&type=script&lang=js&"
import style0 from "./poiList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "poiList.vue"
export default component.exports